export class QuestionAnswer {
  constructor(public question: string,
              public answer?: any,
              public answerType?: string) {
  }
}
